import { render, staticRenderFns } from "./authorizationManage.vue?vue&type=template&id=e1cad676&scoped=true"
import script from "./authorizationManage.vue?vue&type=script&lang=js"
export * from "./authorizationManage.vue?vue&type=script&lang=js"
import style0 from "./authorizationManage.vue?vue&type=style&index=0&id=e1cad676&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1cad676",
  null
  
)

export default component.exports